import {
	InputField,
	Select,
	TableFilterWrapper,
} from '@welbe/web-design-system';
import { OptionProps } from '@welbe/web-design-system/lib/components/molecules/Select/Select';

type FilesFiltersProps = {
	height: number;
	categories: OptionProps[];
	onChangeFilters: (filter: { [key: string]: any }) => void;
};

export const FilesFilters = ({
	height,
	categories,
	onChangeFilters,
}: FilesFiltersProps) => {
	return (
		<TableFilterWrapper height={height}>
			<InputField
				id="name"
				background="white"
				placeholder="Busca por nombre"
				label="Archivo"
				onChange={(data) => onChangeFilters({ name: data })}
			/>
			<Select
				id="categories"
				inputBackground="white"
				placeholder="Selecciona una categoría"
				label="Categoría"
				options={categories}
				disabled={!categories.length}
				onChange={(select) => onChangeFilters({ category: select.id || '' })}
				topDistanceCheckBox="4px"
			/>
		</TableFilterWrapper>
	);
};
